module.exports = __webpack_public_path__ + "static/img/appletscode.d847a69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appletscode.png
// module id = e29P
// module chunks = 47